import { ResourceConfig, SoftDeleteResource } from '@hidat/huijs-resource';
import {
  AnyHash,
  MediaRepoAssetInterface,
  nNumber,
  nString,
  Uuid,
} from '@hidat/huijs-common';
import { SplixerResourceInterface } from './splixer-resource.interface';
import { splixerSystemFields } from './splixer-fields.const';

export const RepoAssetConfig = new ResourceConfig(
  'RepoAsset',
  'repo_assets',
  true,
  true,
)
  .addFields(splixerSystemFields)
  .setSorts({
    createdat: 'createdAt',
  })
  .setDefaultSort('createdat-');

export const RepoAssetIncludes = {
  repository: 'repository',
  previewurl: 'previewurl',
};

export interface RepoAssetInterface
  extends
    SplixerResourceInterface<Uuid>,
    SoftDeleteResource,
    MediaRepoAssetInterface {
  tenantId: Uuid | undefined;
  repositoryId: Uuid | undefined;
  repoPath: nString;
  mediaName: nString;
  mediaHash: nString;
  mediaSize: nNumber;
  encoding: nString;
  encodingAttributes: AnyHash | undefined;
}
